import { render, staticRenderFns } from "./popupGerarPlano.vue?vue&type=template&id=45a88b50"
import script from "./popupGerarPlano.vue?vue&type=script&lang=js"
export * from "./popupGerarPlano.vue?vue&type=script&lang=js"
import style0 from "./popupGerarPlano.vue?vue&type=style&index=0&id=45a88b50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports